import { TOIT_EN_PENTE_MINIMUM_INSULATION_THICKNESS } from "@iko-design-center/shared"
import { SyntheticEvent, useState } from "react"
import { useTranslation } from "react-i18next"
import { updateThermalLayer } from "../../../store/toit-en-pente/thermalPerformance"
import { useToitEnPente } from "../../../store/toit-en-pente/hooks"
import { useModal } from "../../../store/modal/hooks"
import { FEMaterial } from "@iko-design-center/shared"

export function useThermalCalculation() {
  const {
    configurationState,
    thermalPerformance,
    setToitInsulationMaterial,
  } = useToitEnPente()
  const { closeModal } = useModal()
  const { t } = useTranslation() as any

  const [localThermalPerformance, setLocalThermalPerformance] = useState(
    thermalPerformance
  )

  const [
    localToitInsulationMaterial,
    setLocalToitInsulationMaterial,
  ] = useState({
    material: configurationState.toitInsulation.material!,
    valid: true,
  })

  const [editableThicknessValue, setEditableThicknessValue] = useState(
    thermalPerformance.toitInsulation.thickness!.toString()
  )
  const [editableThicknessValid, setEditableThicknessValid] = useState(true)

  function handleEditableThicknessChange(
    event: SyntheticEvent<HTMLInputElement>
  ) {
    const input = event.target as HTMLInputElement
    const type = input.dataset.type!
    let thickness = isNaN(parseInt(input.value)) ? 0 : parseInt(input.value)

    let validThickness = true
    if (!thickness) {
      validThickness = false
    }

    if (type && thickness.toString().length <= 3) {
      const updatedLocalMaterial = {
        material: {
          // @ts-ignore
          ...(configurationState[type].material as FEMaterial),
          thickness,
        },
        valid: validThickness,
      }

      switch (type) {
        case "toitInsulation":
          setLocalToitInsulationMaterial(updatedLocalMaterial)
          break
      }
      setLocalThermalPerformance(
        updateThermalLayer(
          localThermalPerformance,
          updatedLocalMaterial.material,
          type
        )
      )
    } else {
      const value = (event.target as HTMLInputElement).value
      setEditableThicknessValue(value)

      thickness = parseInt(value)
      if (
        thickness &&
        thickness >= TOIT_EN_PENTE_MINIMUM_INSULATION_THICKNESS &&
        thickness.toString().length <= 3
      ) {
        const updatedLocalMaterial = {
          material: {
            // @ts-ignore
            ...(configurationState["toitInsulation"].material as FEMaterial),
            thickness,
          },
          valid: validThickness,
        }

        setLocalToitInsulationMaterial(updatedLocalMaterial)
        setLocalThermalPerformance(
          updateThermalLayer(
            localThermalPerformance,
            updatedLocalMaterial.material,
            "toitInsulation"
          )
        )
        setEditableThicknessValid(true)
      } else {
        setEditableThicknessValid(false)
      }
    }
  }

  function handleCancel() {
    closeModal()
  }

  function handleCardClick(e: SyntheticEvent) {
    e.stopPropagation()
  }

  function handleApply() {
    const allValid = localToitInsulationMaterial.valid && editableThicknessValid

    if (allValid) {
      setToitInsulationMaterial(localToitInsulationMaterial.material)
      closeModal()
    }
  }

  return {
    t,
    thermalPerformance: localThermalPerformance,
    toitInsulationType: configurationState.toitInsulation.type!,

    handleCardClick,
    handleCancel,
    handleApply,

    localToitInsulationMaterial,

    editableThicknessValue,
    editableThicknessValid,
    handleEditableThicknessChange,
  }
}
